import useGetAllPayments from 'modules/easyPay/hooks/useGetAllPayments'
import useSetTotalPayment from 'modules/easyPay/hooks/useSetTotalPayment'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function AccessPay() {
    const navigate = useNavigate()
    const { payments, isLoading } = useGetAllPayments(true)
    const { total, commission } = useSetTotalPayment(payments)
    return (
        <div className="sticky z-20 top-[68px] bg-green-1 py-4 px-6 flex justify-between shadow-[0px 2px 2px 0px #00000026] mb-4 items-center">
            <div className="w-2/3">
                {!isLoading && (
                    <p className=" text-blue-3 text-xl font-black ">
                        {Number(total + commission).toLocaleString()} تومان
                    </p>
                )}

                <p className=" text-white text-xs">
                    تمامی تعهدات قابل پرداخت شما
                </p>
            </div>
            <div className=" w-1/3 text-left items-center">
                <button
                    className=" bg-white rounded-full px-3 py-2 text-blue-3 text-sm"
                    onClick={() => navigate('/easy-pay')}
                >
                    پرداخت آسان
                </button>
            </div>
        </div>
    )
}

// fuck pwa
